export default __webpack_public_path__ + "static/media/FHash5.07e1e9c2.mp3";